import script from "./TagSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./TagSelector.vue?vue&type=script&lang=ts&setup=true"

import "./TagSelector.vue?vue&type=style&index=0&id=9caefeca&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9caefeca"]])

export default __exports__